import styled from '@emotion/styled';
import { grayScale } from '__app/colors';
import { KizenTypography } from '__app/typography';
import { BackBreadcrumbToolbar } from '__components/BackBreadcrumbToolbar';
import LoadingButton from '__components/Button/LoadingButton';
import ButtonWithDropdown from '__components/Button/WithDropdown';
import { SettingsContentCard } from '__components/Card/Card';
import InputControl from '__components/Inputs/InputControl';
import Input from '__components/Kizen/Input';
import { TextEllipsisWithTooltip } from '__components/Kizen/Table';
import { ApiNameInput } from '__pages/SmartConnectors/components/ApiNameInput';

export const StyledToolbar = styled(BackBreadcrumbToolbar)`
  & > .toolbar > div:first-of-type {
    flex: 0 0 240px;
    @media screen and (max-width: 767px) {
      flex: 0 0 31px;
    }
  }
`;

export const StyledPageHeader = styled(TextEllipsisWithTooltip)`
  width: 0;
  flex-grow: 1;
  text-align: center;
`;

export const StyledPage = styled.section`
  margin: 20px 0;
`;

export const StyledSettingsContentCard = styled(SettingsContentCard)`
  margin: 20px auto;
`;

export const StyledButtons = styled.div`
  display: flex;
  gap: 10px;
  height: 36px;
`;

export const StyledButtonWithDropdown = styled(ButtonWithDropdown)`
  margin: 0;
`;

export const StyledLoadingButton = styled(LoadingButton)`
  margin: 0;
`;

export const StyledStepHeader = styled(KizenTypography)`
  margin-bottom: 20px;
  &:not(:first-of-type) {
    margin-top: 25px;
  }
`;

export const StyledTableToolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 36px;
  margin-bottom: 20px;
`;

export const StyledExecutionsTableWrapper = styled.div`
  margin: 20px 0 0;
`;

export const StyledSearchInput = styled(Input)`
  max-width: 200px;

  label {
    margin: 0;
  }

  .input-wrapper {
    margin: 0;
    background-color: ${grayScale.white};
  }

  input {
    min-width: 0;
    padding-right: 0;
  }
`;

export const StyleRelativeWrapper = styled.div`
  position: relative;
`;

export const StyledApiNameInput = styled(ApiNameInput)`
  position: absolute;
  width: 100%;
  top: -40px;
`;

export const StyledStatusInputControl = styled(InputControl)`
  position: absolute;
  width: 100%;
  top: -40px;
  & > label {
    margin-bottom: 23px;
  }
`;
